import { MONTHS, formatMoney } from "./constants";
import type { SpendingAnswerProps } from "./types";
import { getSpendingComparison } from "./utils";
import {
  AnswerHeading,
  AnswerValue,
  CategoryRows,
  CategoryFill,
  Comparison,
  ControlRow,
  Explanation,
  MoneySummary,
  Selector,
  SelectorGroup,
} from "./styles";

export function SpendingAnswer({
  month,
  selectedMonth,
  onMonthChange,
}: SpendingAnswerProps) {
  const remaining = month.income - month.expenses;
  const comparison = getSpendingComparison(selectedMonth);
  const monthButtons = MONTHS.map((item, index) => {
    const isSelected = selectedMonth === index;
    return (
      <Selector
        key={item.name}
        type="button"
        aria-label={item.name}
        aria-pressed={isSelected}
        onClick={() => onMonthChange(index)}
      >
        {item.shortName}
      </Selector>
    );
  });
  const categoryRows = month.categories.map(({ name, amount }) => {
    const width = (amount / month.expenses) * 100;
    const formattedAmount = formatMoney(amount);
    return (
      <div key={name}>
        <dt>{name}</dt>
        <dd>{formattedAmount}</dd>
        <span aria-hidden="true">
          <CategoryFill $width={width} />
        </span>
      </div>
    );
  });
  return (
    <>
      <ControlRow>
        <AnswerHeading id="spending-answer-title">
          Money in. Money out.
        </AnswerHeading>
        <SelectorGroup role="group" aria-label="Sample month">
          {monthButtons}
        </SelectorGroup>
      </ControlRow>
      <AnswerValue>
        {formatMoney(remaining)} <span>left after expenses</span>
      </AnswerValue>
      <Explanation>{month.name} · illustrative transactions</Explanation>
      <Comparison>{comparison}</Comparison>
      <MoneySummary>
        <div>
          <dt>Income</dt>
          <dd>{formatMoney(month.income)}</dd>
        </div>
        <div>
          <dt>Expenses</dt>
          <dd>{formatMoney(month.expenses)}</dd>
        </div>
      </MoneySummary>
      <CategoryRows aria-label="Expense categories">
        {categoryRows}
      </CategoryRows>
    </>
  );
}
